import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
  obsidian: {
    name: 'Obsidian Green',
    emoji: '💚',
    vars: {
      '--primary': '#00c853',
      '--primary-dark': '#009624',
      '--primary-light': '#69f0ae',
      '--primary-gradient': 'linear-gradient(135deg, #00c853, #1de9b6)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #00e676, #00bcd4)',
      '--secondary': '#1de9b6',
      '--bg-main': '#0a1628',
      '--bg-dark': '#060e1a',
      '--bg-card': '#0f2040',
      '--bg-card-hover': '#162848',
      '--bg-sidebar': '#060e1a',
      '--text-primary': '#e8f5e9',
      '--text-secondary': '#80cbc4',
      '--text-light': '#4db6ac',
      '--border': '#1a3a5c',
      '--border-green': '#00c85340',
      '--shadow-md': '0 4px 16px rgba(0,200,83,0.1)',
      '--shadow-lg': '0 8px 32px rgba(0,200,83,0.15)',
      '--shadow-green': '0 0 20px rgba(0,200,83,0.2)',
    }
  },
  neonnoir: {
    name: 'Neon Noir',
    emoji: '⚡',
    vars: {
      '--primary': '#00e5ff',
      '--primary-dark': '#00b8d4',
      '--primary-light': '#80deea',
      '--primary-gradient': 'linear-gradient(135deg, #00e5ff, #ff1744)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #18ffff, #ff4569)',
      '--secondary': '#ff1744',
      '--bg-main': '#0a0a0f',
      '--bg-dark': '#050508',
      '--bg-card': '#12121a',
      '--bg-card-hover': '#1a1a25',
      '--bg-sidebar': '#050508',
      '--text-primary': '#e0f7fa',
      '--text-secondary': '#80deea',
      '--text-light': '#4dd0e1',
      '--border': '#1a1a2e',
      '--border-green': '#00e5ff40',
      '--shadow-md': '0 4px 16px rgba(0,229,255,0.1)',
      '--shadow-lg': '0 8px 32px rgba(0,229,255,0.15)',
      '--shadow-green': '0 0 20px rgba(0,229,255,0.25)',
    }
  },
  ocean: {
    name: 'Ocean Blue',
    emoji: '🌊',
    vars: {
      '--primary': '#0ea5e9',
      '--primary-dark': '#0369a1',
      '--primary-light': '#7dd3fc',
      '--primary-gradient': 'linear-gradient(135deg, #0ea5e9, #6366f1)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #38bdf8, #818cf8)',
      '--secondary': '#6366f1',
      '--bg-main': '#030f1a',
      '--bg-dark': '#020810',
      '--bg-card': '#071e35',
      '--bg-card-hover': '#0a2a4a',
      '--bg-sidebar': '#020810',
      '--text-primary': '#e0f2fe',
      '--text-secondary': '#7dd3fc',
      '--text-light': '#38bdf8',
      '--border': '#0c3a5a',
      '--border-green': '#0ea5e940',
      '--shadow-md': '0 4px 16px rgba(14,165,233,0.1)',
      '--shadow-lg': '0 8px 32px rgba(14,165,233,0.15)',
      '--shadow-green': '0 0 20px rgba(14,165,233,0.2)',
    }
  },
  emerald: {
    name: 'Emerald Dusk',
    emoji: '🌿',
    vars: {
      '--primary': '#10b981',
      '--primary-dark': '#059669',
      '--primary-light': '#6ee7b7',
      '--primary-gradient': 'linear-gradient(135deg, #10b981, #0ea5e9)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #34d399, #38bdf8)',
      '--secondary': '#0ea5e9',
      '--bg-main': '#0d1f1a',
      '--bg-dark': '#081510',
      '--bg-card': '#132d24',
      '--bg-card-hover': '#1a3d30',
      '--bg-sidebar': '#081510',
      '--text-primary': '#d1fae5',
      '--text-secondary': '#6ee7b7',
      '--text-light': '#34d399',
      '--border': '#1a4a35',
      '--border-green': '#10b98140',
      '--shadow-md': '0 4px 16px rgba(16,185,129,0.1)',
      '--shadow-lg': '0 8px 32px rgba(16,185,129,0.15)',
      '--shadow-green': '0 0 20px rgba(16,185,129,0.2)',
    }
  },
  violet: {
    name: 'Violet Haze',
    emoji: '🔮',
    vars: {
      '--primary': '#8b5cf6',
      '--primary-dark': '#7c3aed',
      '--primary-light': '#c4b5fd',
      '--primary-gradient': 'linear-gradient(135deg, #8b5cf6, #06b6d4)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #a78bfa, #22d3ee)',
      '--secondary': '#06b6d4',
      '--bg-main': '#16132a',
      '--bg-dark': '#0e0b1e',
      '--bg-card': '#231e42',
      '--bg-card-hover': '#2e2855',
      '--bg-sidebar': '#0e0b1e',
      '--text-primary': '#ede9fe',
      '--text-secondary': '#c4b5fd',
      '--text-light': '#a78bfa',
      '--border': '#3d3570',
      '--border-green': '#8b5cf640',
      '--shadow-md': '0 4px 16px rgba(139,92,246,0.1)',
      '--shadow-lg': '0 8px 32px rgba(139,92,246,0.15)',
      '--shadow-green': '0 0 20px rgba(139,92,246,0.2)',
    }
  },
  copper: {
    name: 'Copper Sunset',
    emoji: '🌅',
    vars: {
      '--primary': '#f97316',
      '--primary-dark': '#ea580c',
      '--primary-light': '#fdba74',
      '--primary-gradient': 'linear-gradient(135deg, #f97316, #eab308)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #fb923c, #facc15)',
      '--secondary': '#eab308',
      '--bg-main': '#1c1208',
      '--bg-dark': '#120c04',
      '--bg-card': '#2d1e0e',
      '--bg-card-hover': '#3d2a14',
      '--bg-sidebar': '#120c04',
      '--text-primary': '#ffedd5',
      '--text-secondary': '#fdba74',
      '--text-light': '#fb923c',
      '--border': '#5a3010',
      '--border-green': '#f9731640',
      '--shadow-md': '0 4px 16px rgba(249,115,22,0.1)',
      '--shadow-lg': '0 8px 32px rgba(249,115,22,0.15)',
      '--shadow-green': '0 0 20px rgba(249,115,22,0.2)',
    }
  },
  arctic: {
    name: 'Arctic White',
    emoji: '❄️',
    vars: {
      '--primary': '#0ea5e9',
      '--primary-dark': '#0284c7',
      '--primary-light': '#7dd3fc',
      '--primary-gradient': 'linear-gradient(135deg, #0ea5e9, #6366f1)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #38bdf8, #818cf8)',
      '--secondary': '#6366f1',
      '--bg-main': '#f0f9ff',
      '--bg-dark': '#e0f2fe',
      '--bg-card': '#ffffff',
      '--bg-card-hover': '#f0f9ff',
      '--bg-sidebar': '#ffffff',
      '--text-primary': '#0c4a6e',
      '--text-secondary': '#0369a1',
      '--text-light': '#0ea5e9',
      '--border': '#bae6fd',
      '--border-green': '#0ea5e940',
      '--shadow-md': '0 4px 16px rgba(14,165,233,0.1)',
      '--shadow-lg': '0 8px 32px rgba(14,165,233,0.15)',
      '--shadow-green': '0 0 20px rgba(14,165,233,0.15)',
    }
  },
  mint: {
    name: 'Mint Fresh',
    emoji: '🌱',
    vars: {
      '--primary': '#10b981',
      '--primary-dark': '#059669',
      '--primary-light': '#6ee7b7',
      '--primary-gradient': 'linear-gradient(135deg, #10b981, #06b6d4)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #34d399, #22d3ee)',
      '--secondary': '#06b6d4',
      '--bg-main': '#f0fdf4',
      '--bg-dark': '#dcfce7',
      '--bg-card': '#ffffff',
      '--bg-card-hover': '#f0fdf4',
      '--bg-sidebar': '#ffffff',
      '--text-primary': '#064e3b',
      '--text-secondary': '#065f46',
      '--text-light': '#059669',
      '--border': '#a7f3d0',
      '--border-green': '#10b98140',
      '--shadow-md': '0 4px 16px rgba(16,185,129,0.1)',
      '--shadow-lg': '0 8px 32px rgba(16,185,129,0.15)',
      '--shadow-green': '0 0 20px rgba(16,185,129,0.15)',
    }
  },
  rosegold: {
    name: 'Rose Gold',
    emoji: '🌸',
    vars: {
      '--primary': '#f43f5e',
      '--primary-dark': '#e11d48',
      '--primary-light': '#fda4af',
      '--primary-gradient': 'linear-gradient(135deg, #f43f5e, #f59e0b)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #fb7185, #fbbf24)',
      '--secondary': '#f59e0b',
      '--bg-main': '#fff1f2',
      '--bg-dark': '#ffe4e6',
      '--bg-card': '#ffffff',
      '--bg-card-hover': '#fff1f2',
      '--bg-sidebar': '#ffffff',
      '--text-primary': '#881337',
      '--text-secondary': '#be123c',
      '--text-light': '#e11d48',
      '--border': '#fecdd3',
      '--border-green': '#f43f5e40',
      '--shadow-md': '0 4px 16px rgba(244,63,94,0.1)',
      '--shadow-lg': '0 8px 32px rgba(244,63,94,0.15)',
      '--shadow-green': '0 0 20px rgba(244,63,94,0.15)',
    }
  },
  pearl: {
    name: 'Pearl Grey',
    emoji: '🩶',
    vars: {
      '--primary': '#8b5cf6',
      '--primary-dark': '#7c3aed',
      '--primary-light': '#c4b5fd',
      '--primary-gradient': 'linear-gradient(135deg, #8b5cf6, #ec4899)',
      '--primary-gradient-hover': 'linear-gradient(135deg, #a78bfa, #f472b6)',
      '--secondary': '#ec4899',
      '--bg-main': '#f8f9fa',
      '--bg-dark': '#e9ecef',
      '--bg-card': '#ffffff',
      '--bg-card-hover': '#f8f9fa',
      '--bg-sidebar': '#ffffff',
      '--text-primary': '#212529',
      '--text-secondary': '#495057',
      '--text-light': '#6c757d',
      '--border': '#dee2e6',
      '--border-green': '#8b5cf640',
      '--shadow-md': '0 4px 16px rgba(139,92,246,0.1)',
      '--shadow-lg': '0 8px 32px rgba(139,92,246,0.15)',
      '--shadow-green': '0 0 20px rgba(139,92,246,0.15)',
    }
  }
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(
    localStorage.getItem('vantage_theme') || 'obsidian'
  );

  useEffect(() => {
    applyTheme(currentTheme);
  }, [currentTheme]);

  useEffect(() => {
    applyTheme(currentTheme);
  }, []);

  const applyTheme = (themeName) => {
    const theme = themes[themeName];
    if (!theme) return;
    const root = document.documentElement;
    Object.entries(theme.vars).forEach(([key, value]) => {
      root.style.setProperty(key, value);
    });
    localStorage.setItem('vantage_theme', themeName);
  };

  const switchTheme = (themeName) => {
    setCurrentTheme(themeName);
  };

  return (
    <ThemeContext.Provider value={{ currentTheme, switchTheme, themes }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeProvider;